/* @flow */
// typecheck: ignore file
import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

type Props = {
  children: any,
  user: {
    featureFlags: { web_admin_console: boolean },
    organizations: { id: number }[],
  }
}

class AdminConsoleAccess extends React.Component {
  props: Props;

  render() {
    const { user } = this.props;

    const access = (
      user &&
      user.featureFlags['web_admin_console'] &&
      user.organizations.length > 0
    );

    if (!access) {
      return null;
    }

    return this.props.children;
  }
}

const withUser = graphql(gql`
  query {
    user: me {
      id
      featureFlags {
        web_admin_console
      }
      organizations: organizations(first: 1, affiliation_status: [admin pending_admin]) {
        id
      }
    }
  }`, {
    props: ({ data }) => ({ user: data.user }),
  }
);

export { AdminConsoleAccess };
export default withUser(AdminConsoleAccess);



// WEBPACK FOOTER //
// ./src/admin/components/AdminConsoleAccess.jsx